import React from "react";
import { Link } from "react-router-dom";

const Banner = () => {
  return (
    <section className="banner-area pt-120 pb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-content text-center">
              <span className="sub-titles banner-sub text-white fs-15 fw-semibold">
                Audit fournisseur, pricing et récupération de marge
              </span>
              <h1 className="fs-60 mt-3 fw-bold text-white">
                Récupérez les marges perdues dans vos contrats, factures et conditions tarifaires
              </h1>
              <p className="fs-18 text-white">
                WBC audite vos flux fournisseurs, FEC, contrats, tarifs, escomptes, ristournes de bon paiement, avoirs, doublons et écarts de prix pour transformer les anomalies en revenus recouvrés.
              </p>
              <p className="fs-18 text-white">
                Chaque mission est structurée pour produire une proposition claire : périmètre, méthode d'audit, potentiel de récupération, livrables, calendrier et plan d'action pour sécuriser les marges futures.
              </p>
              <div className="section-content-btn justify-content-center">
                <Link to="/services" className="btn-lg primary-btn fs-18 fw-semibold br-10">
                  Voir les missions
                </Link>
                <Link to="/knowledge-catalog" className="btn-lg white-border-btn fs-18 fw-semibold br-10">
                  Méthode d'audit
                </Link>
              </div>
              <div className="hero-proof-strip">
                <span>ITM : mise en place et analyse d'écarts de prix</span>
                <span>Carrefour : contrôle fournisseur et pricing</span>
                <span>30 à 40% des revenus identifiés peuvent être récupérés selon dossier</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;